import { FilterOutlined } from '@ant-design/icons';
import { Button, DatePicker } from 'antd';
import dayjs from 'dayjs';

import { DATE_PICKER_FORMAT, PREFIX, rangePickerLocale } from '@app/constants';
import type { NSmallGlobalEntities } from '@app/types/SmallGlobalEntities';

import '@app/pages/Messages/MessagesList/styles/MessagesPageHeader.desktop.scss';
import '@app/pages/Messages/MessagesList/styles/MessagesPageHeader.mobile.scss';

const { RangePicker } = DatePicker;

interface MessagesPageHeaderPropsType {
  datesRange: NSmallGlobalEntities.RangeValue;
  setDatesRange: React.Dispatch<
    React.SetStateAction<NSmallGlobalEntities.RangeValue>
  >;
  fetchClientsMessages: () => Promise<void>;
}

export const MessagesPageHeader = ({
  fetchClientsMessages,
  datesRange,
  setDatesRange,
}: MessagesPageHeaderPropsType) => {
  const handleDateChange = (dates: NSmallGlobalEntities.RangeValue) => {
    if (dates?.length) {
      const startDate = dates[0] ? dayjs(dates[0]).startOf('day') : null;
      const endDate = dates[1] ? dayjs(dates[1]).startOf('day') : null;

      if (endDate && startDate) {
        const maxEndDate = startDate.clone().add(7, 'days').endOf('day');
        setDatesRange([
          startDate,
          endDate.isAfter(maxEndDate) ? maxEndDate : endDate,
        ]);
      } else {
        setDatesRange(dates);
      }
    }
  };

  const disabledEndDate = (currentDate: dayjs.Dayjs) => {
    return currentDate.isAfter(dayjs(), 'day');
  };

  return (
    <div className={`${PREFIX}messages-page-header`}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
        <span>Период:</span>
        <RangePicker
          classNames={{ popup: { root: 'calendars' } }}
          locale={rangePickerLocale}
          allowClear={false}
          format={DATE_PICKER_FORMAT}
          value={datesRange}
          onChange={handleDateChange}
          disabledDate={disabledEndDate}
        />
      </div>
      <Button
        block
        icon={<FilterOutlined />}
        type="primary"
        onClick={fetchClientsMessages}
        className="action-button"
      >
        Показать
      </Button>
    </div>
  );
};
